import * as api from '../api/insights.js';
import q from '../query.js';
import { caseFilterhash, } from '@debbie/common/dist/insights/index.js';
export const creditorWebDashboardKey = (creditorId) => `creditor-web-dashboard-${creditorId}`;
export const useCreditorWebDashboard = (creditorId) => q.query(creditorWebDashboardKey(creditorId), () => (creditorId ? api.getCreditorWebDashboard(creditorId) : null), []);
export const aggregationKey = (type, caseFilter) => `filter-aggregation-${type}-${caseFilterhash(caseFilter)}`;
export const useAggregation = (type, caseFilter) => q.query(aggregationKey(type, caseFilter), () => api.getAggregation(type, caseFilter), []);
export const downloadedReportKey = (id) => `downloaded-report-${id}`;
export const useDownloadedReport = (id) => q.query(downloadedReportKey(id), () => api.getDownload(id), []);
//# sourceMappingURL=index.js.map